import React, { useCallback, useRef } from 'react';
import { Button } from 'primereact/button';
import { FileUpload } from 'primereact/fileupload';
import { useTranslation } from 'react-i18next';
import './LogoUpload.css';
import { toBase64 } from '../../../../../../helpers/invoiceHelpers';
import { showToast } from '../../../../../../helpers/showToast';
import { Tooltip } from 'primereact/tooltip';

export const LogoUpload = ({ name, field, form, tooltip, ...props }) => {
  const { t } = useTranslation();
  const ref = useRef();

  const fileUploadRef = useRef(null);

  const onTemplateSelect = async (e) => {
    const type = e.files[0]?.type;

    if (!type?.includes('image')) {
      fileUploadRef.current.clear();
      showToast({
        data: {
          variant: 'error',
          text: t('invalid-file-type'),
        },
      });
      return;
    }

    const logoImage = await toBase64(e.files[0]);
    form.setFieldValue(field.name, logoImage);
  };

  const onTemplateRemove = (_file, callback) => {
    form.setFieldValue(field.name, '');
    callback();
  };

  const headerTemplate = (options) => {
    const { chooseButton, uploadButton, cancelButton } = options;
    return (
      <div
        style={{
          display: 'none',
        }}
      >
        {chooseButton}
        {uploadButton}
        {cancelButton}
      </div>
    );
  };

  const EmptyTemplate = useCallback(() => {
    return (
      <div className="empty-template">
        <Tooltip target={ref} showDelay="200" />

        <Button
          icon="pi pi-upload"
          text
          type="button"
          onClick={() => {
            fileUploadRef.current.getInput().click();
          }}
        />
        <div className="label">
          {t('upload-logo')}{' '}
          {tooltip && (
            <i
              ref={ref}
              className="p-0 pi pi-info-circle"
              data-pr-tooltip={t(tooltip)}
            />
          )}
        </div>
      </div>
    );
  }, [fileUploadRef]);

  const itemTemplate = (file, itemProps) => {
    return (
      <div className="flex items-center flex-wrap rounded-2xl p-4 gap-3 mt-8">
        <img alt="logo" src={file.objectURL} />
        <div className="d-flex">
          <Button
            text
            severity="secondary"
            icon="pi pi-trash"
            type="button"
            onClick={() => onTemplateRemove(file, itemProps.onRemove)}
          />
          <Button
            icon="pi pi-upload"
            text
            type="button"
            onClick={() => {
              fileUploadRef.current.getInput().click();
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <FileUpload
      accept="image/*"
      auto
      customUpload={true}
      className="file-upload mt-8"
      contentClassName="bg-transparent"
      ref={fileUploadRef}
      name={name}
      headerTemplate={headerTemplate}
      itemTemplate={itemTemplate}
      emptyTemplate={EmptyTemplate}
      uploadHandler={onTemplateSelect}
      {...props}
    />
  );
};
